// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-content-row {
  display: table-row;
  color: inherit;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.dl-content-row:hover {
  background-color: var(--g-color-base-simple-hover-solid);
  cursor: pointer;
}
.dl-content-row:hover .dl-content-row__btn-favorite {
  visibility: visible;
}
.dl-content-row__empty-row {
  display: table-row;
}
.dl-content-row__content-cell, .dl-content-row__empty-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: table-cell;
  box-sizing: content-box;
  overflow-wrap: break-word;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid var(--g-color-line-generic);
}
.dl-content-row__content-cell {
  padding: 0 10px;
}
.dl-content-row__content-cell_title {
  max-width: 401px;
}
.dl-content-row__content-cell_author {
  width: 165px;
  max-width: 165px;
}
.dl-content-row__content-cell_date {
  width: 150px;
  max-width: 150px;
}
.dl-content-row__content-cell_controls {
  width: 100px;
  max-width: 100px;
}
.dl-content-row__empty-cell {
  color: var(--g-color-text-secondary);
}
.dl-content-row__title-col {
  display: flex;
  align-items: center;
}
.dl-content-row__title-col_is-mobile {
  max-width: 200px;
}
.dl-content-row__title-col-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 12px;
}
.dl-content-row__author-text {
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dl-content-row__control-col {
  display: flex;
  justify-content: flex-end;
}
.dl-content-row__btn-favorite {
  color: var(--g-color-base-misc-heavy-hover);
  border-radius: 4px;
  visibility: hidden;
}
.dl-content-row__btn-favorite_is-favorite {
  visibility: visible;
}
.dl-content-row__btn-favorite_is-favorite svg {
  color: var(--g-color-base-misc-heavy-hover);
}
.dl-content-row__btn-favorite:hover {
  color: var(--g-color-base-misc-heavy-hover);
}
.dl-content-row__btn-actions {
  margin-left: 8px;
}
.dl-content-row_mobile .dl-content-row__content-cell {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
  padding: 0;
}
.dl-content-row_mobile .dl-content-row__title-col {
  padding-right: 8px;
}
.dl-content-row_mobile .dl-content-row__content-cell_date {
  width: 80px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/workbooks/components/Table/WorkbookEntriesTable/Row/Row.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAGI,kBAAA;EACA,cAAA;EACA,6BAAA;EAAA,qBAAA;AAHJ;AAKI;EACI,wDAAA;EACA,eAAA;AAHR;AAKQ;EACI,mBAAA;AAHZ;AAOI;EACI,kBAAA;AALR;AAQI;EClBA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDsBxB,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EAEA,oDAAA;AANR;AASI;EACI,eAAA;AAPR;AASQ;EACI,gBAAA;AAPZ;AAUQ;EACI,YAAA;EACA,gBAAA;AARZ;AAWQ;EACI,YAAA;EACA,gBAAA;AATZ;AAYQ;EACI,YAAA;EACA,gBAAA;AAVZ;AAcI;EACI,oCAAA;AAZR;AAeI;EACI,aAAA;EACA,mBAAA;AAbR;AAeQ;EACI,gBAAA;AAbZ;AAiBI;EClEA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDqExB,iBAAA;AAbR;AAgBI;EACI,yBAAA;EACA,uBAAA;EACA,mBAAA;AAdR;AAiBI;EACI,aAAA;EACA,yBAAA;AAfR;AAkBI;EACI,2CAAA;EACA,kBAAA;EACA,kBAAA;AAhBR;AAkBQ;EACI,mBAAA;AAhBZ;AAkBY;EACI,2CAAA;AAhBhB;AAoBQ;EACI,2CAAA;AAlBZ;AAsBI;EACI,gBAAA;AApBR;AAwBQ;ECiEJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;EDlEQ,UAAA;AAnBZ;AAsBQ;EACI,kBAAA;AApBZ;AAuBQ;EACI,WAAA;AArBZ","sourcesContent":[".dl-content-row {\n  display: table-row;\n  color: inherit;\n  text-decoration: none;\n}\n.dl-content-row:hover {\n  background-color: var(--g-color-base-simple-hover-solid);\n  cursor: pointer;\n}\n.dl-content-row:hover .dl-content-row__btn-favorite {\n  visibility: visible;\n}\n.dl-content-row__empty-row {\n  display: table-row;\n}\n.dl-content-row__content-cell, .dl-content-row__empty-cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: table-cell;\n  box-sizing: content-box;\n  overflow-wrap: break-word;\n  text-align: left;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.dl-content-row__content-cell {\n  padding: 0 10px;\n}\n.dl-content-row__content-cell_title {\n  max-width: 401px;\n}\n.dl-content-row__content-cell_author {\n  width: 165px;\n  max-width: 165px;\n}\n.dl-content-row__content-cell_date {\n  width: 150px;\n  max-width: 150px;\n}\n.dl-content-row__content-cell_controls {\n  width: 100px;\n  max-width: 100px;\n}\n.dl-content-row__empty-cell {\n  color: var(--g-color-text-secondary);\n}\n.dl-content-row__title-col {\n  display: flex;\n  align-items: center;\n}\n.dl-content-row__title-col_is-mobile {\n  max-width: 200px;\n}\n.dl-content-row__title-col-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 12px;\n}\n.dl-content-row__author-text {\n  overflow-wrap: break-word;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dl-content-row__control-col {\n  display: flex;\n  justify-content: flex-end;\n}\n.dl-content-row__btn-favorite {\n  color: var(--g-color-base-misc-heavy-hover);\n  border-radius: 4px;\n  visibility: hidden;\n}\n.dl-content-row__btn-favorite_is-favorite {\n  visibility: visible;\n}\n.dl-content-row__btn-favorite_is-favorite svg {\n  color: var(--g-color-base-misc-heavy-hover);\n}\n.dl-content-row__btn-favorite:hover {\n  color: var(--g-color-base-misc-heavy-hover);\n}\n.dl-content-row__btn-actions {\n  margin-left: 8px;\n}\n.dl-content-row_mobile .dl-content-row__content-cell {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n  padding: 0;\n}\n.dl-content-row_mobile .dl-content-row__title-col {\n  padding-right: 8px;\n}\n.dl-content-row_mobile .dl-content-row__content-cell_date {\n  width: 80px;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
